import React from 'react';
import CommonAreasTable from '../../components/CommonAreasTable';

interface PropertyCommonAreasProps {
  property: any;
}

const PropertyCommonAreas = ({ property }: PropertyCommonAreasProps) => (
  <CommonAreasTable property={property} />
);

export default PropertyCommonAreas;
